/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  submit: {
    defaultMessage: 'Submit',
    id: 'PromptSupplementalInformation.submit',
  },
  verify: {
    defaultMessage: 'Verify',
    id: 'PromptSupplementalInformation.verify',
  },
});
